import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiNeedTotpTfaError } from '@/core/error/transport/customErrors/tmApiNeedTotpTfaError'
import { oauthEndpointProvidersPredicateFn } from '@/services/transport/errorsProcessing/rules/oauth/types'

export const oauth2FATotpRequiredErrorRule: CustomErrorRule = {
  subCodes: ['auth.enter_totp_two_factor_code'],
  klass: TmApiNeedTotpTfaError,
  predicateFn: oauthEndpointProvidersPredicateFn,
}
